// @mui material components
import {
  Card,
  Grid,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  // InputAdornment,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
} from "@mui/material";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import DataTable from "theme/Tables/DataTable";
import MDBadge from "theme/components/MDBadge";

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import ApiConfig from "apiConfig";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";
// import { Helmet } from "react-helmet";

function AleroSwitch() {
  const navigate = useNavigate();

  const pageTitle = "Alero Switch";
  usePageTitle(pageTitle);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [transactions, setTransactions] = useState([]);
  const [digitalWallets, setDigitalWallets] = useState([]);
  const [digitalWalletCurrencies, setDigitalWalletCurrencies] = useState([]);
  const [sourceCurrencies, setSourceCurrencies] = useState([]);
  const [destinationCurrencies, setDestinationCurrencies] = useState([]);
  const [sourceWallet, setSourceWallet] = useState(null);
  const [destinationWallet, setDestinationWallet] = useState(null);
  const [sourceWalletObject, setSourceWalletObject] = useState(null);
  const [destinationWalletObject, setDestinationWalletObject] = useState(null);
  const [sourceCurrency, setSourceCurrency] = useState(null);
  const [destinationCurrency, setDestinationCurrency] = useState(null);
  const [sourceAmount, setSourceAmount] = useState(null);
  // const [destinationAmount, setDestinationAmount] = useState(null);
  // const [state, setState] = useState({});

  // const [calculated, setCalculated] = useState(false);
  const [sourceAmountLabel, setSourceAmountLabel] = useState("Amount");
  // const [destinationAmountLabel, setDestinationAmountLabel] = useState("Amount");
  // const [actionBtnLabel, setActionBtnLabel] = useState("Calculated");
  const [destinationDetails, setDestinationDetails] = useState({});

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [commercials, setCommercials] = useState(null);

  const tableColumns = [
    // { Header: "Currency", accessor: "currency", align: "left" },
    { Header: "View", accessor: "view", align: "left" },
    { Header: "From", accessor: "from", align: "left" },
    { Header: "To", accessor: "to", align: "left" },
    { Header: "Amount", accessor: "amount", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Created", accessor: "created", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((transaction) => {
      let statusColor = "warning";
      if (transaction.status.toUpperCase() === "COMPLETED") {
        statusColor = "success";
      } else if (transaction.status.toUpperCase() === "PENDING") {
        statusColor = "dark";
      } else if (transaction.status.toUpperCase() === "ERROR") {
        statusColor = "error";
      } else if (transaction.status.toUpperCase() === "FAILED") {
        statusColor = "error";
      } else if (transaction.status.toUpperCase() === "PROCESSING") {
        statusColor = "warning";
      } else {
        statusColor = "info";
      }

      rows.push({
        view: (
          <Link to={`/switch/${transaction.reference}`}>
            <MDButton variant="outlined" color="dark" iconOnly circular>
              <Icon sx={{ fontWeight: "bold" }}>keyboard_double_arrow_right</Icon>
            </MDButton>
          </Link>
        ),
        from: (
          <MDBox display="flex" alignItems="center" justifyContent="left">
            <img
              alt=""
              src={`${ApiConfig.api_media_url}${transaction.source.wallet.logo}`}
              width="20"
              mr={3}
            />
            <MDBox ml={2}>{transaction.source.wallet.title}</MDBox>
          </MDBox>
        ),
        to: (
          <MDBox display="flex" alignItems="flex-start" justifyContent="left">
            <img
              alt=""
              src={`${ApiConfig.api_media_url}${transaction.destination.wallet.logo}`}
              width="20"
              mr={3}
            />
            <MDBox ml={2}>{transaction.destination.wallet.title}</MDBox>
          </MDBox>
        ),
        amount: (
          <b>
            {transaction.source.currency.symbol}{" "}
            {(transaction.amount / 100).toLocaleString("en-US", {
              minimumFractionDigits: transaction.source.currency.multiplier.toString().length - 1,
              maximumFractionDigits: transaction.source.currency.multiplier.toString().length - 1,
            })}
          </b>
        ),
        status: (
          <MDBox>
            <MDBadge
              badgeContent={transaction.status}
              variant="contained"
              container
              color={statusColor}
            />
          </MDBox>
        ),
        created: transaction.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("switch/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setDigitalWallets(result.data.data.wallets);
            setDigitalWalletCurrencies(result.data.data.wallet_currencies);

            const rows = buildRateRows(result.data.data.transactions);
            setTransactions(rows);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("switch")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (sourceCurrency !== null) {
      setSourceAmountLabel(`${sourceCurrency} Amount`);
    }
  }, [sourceCurrency]);

  function handleSourceWalletChange(value) {
    setSourceWallet(value);
    setSourceCurrency(null);
    setSourceCurrencies(digitalWalletCurrencies[value]);

    digitalWallets.forEach((item) => {
      if (item.code === value) {
        setSourceWalletObject(item);
      }
    });

    // console.log(sourceWalletObject);
  }

  function handleDestinationWalletChange(value) {
    setDestinationWallet(value);
    setDestinationCurrency(null);
    setDestinationCurrencies(digitalWalletCurrencies[value]);
    setDestinationDetails({});

    digitalWallets.forEach((item) => {
      if (item.code === value) {
        setDestinationWalletObject(item);
      }
    });

    // console.log(destinationWalletObject);
  }

  async function calculate() {
    if (sourceWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a source wallet");
      setOpen(true);
      return;
    }

    if (sourceCurrency === null) {
      setSeverity("error");
      setErrMsg("Please select a source wallet currency");
      setOpen(true);
      return;
    }

    if (destinationWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a destination wallet");
      setOpen(true);
      return;
    }

    if (destinationCurrency === null) {
      setSeverity("error");
      setErrMsg("Please select a destination wallet currency");
      setOpen(true);
      return;
    }

    if (sourceAmount === null || sourceAmount <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid amount.");
      setOpen(true);
      return;
    }

    if (destinationWallet !== "ALERO") {
      if (destinationDetails === null || destinationDetails.length < 1) {
        setSeverity("error");
        setErrMsg(`Please provide your ${destinationWalletObject.title} details.`);
        setOpen(true);
        return;
      }

      const passed = destinationWalletObject.parameters.every((param) => {
        if (!(param.key in destinationDetails)) {
          setSeverity("error");
          setErrMsg(`Your ${destinationWalletObject.title} ${param.display_name} is required`);
          setOpen(true);
          return false;
        }

        return true;
      });

      if (!passed) {
        return;
      }
    } else {
      setDestinationDetails({});
    }

    const params = {
      amount: sourceAmount * 100,
      source: {
        wallet: sourceWallet,
        currency: sourceCurrency,
      },
      destination: {
        wallet: destinationWallet,
        currency: destinationCurrency,
        details: destinationDetails,
      },
    };
    // console.log(params);

    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("switch/calculate.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setCommercials(response.data.data);
          setShowConfirmDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function createTransaction() {
    if (sourceWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a source wallet");
      setOpen(true);
      return;
    }

    if (sourceCurrency === null) {
      setSeverity("error");
      setErrMsg("Please select a source wallet currency");
      setOpen(true);
      return;
    }

    if (destinationWallet === null) {
      setSeverity("error");
      setErrMsg("Please select a destination wallet");
      setOpen(true);
      return;
    }

    if (destinationCurrency === null) {
      setSeverity("error");
      setErrMsg("Please select a destination wallet currency");
      setOpen(true);
      return;
    }

    if (sourceAmount === null || sourceAmount <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid amount.");
      setOpen(true);
      return;
    }

    if (destinationWallet !== "ALERO") {
      if (destinationDetails === null || destinationDetails.length < 1) {
        setSeverity("error");
        setErrMsg(`Please provide your ${destinationWalletObject.title} details.`);
        setOpen(true);
        return;
      }

      const passed = destinationWalletObject.parameters.every((param) => {
        if (!(param.key in destinationDetails)) {
          setSeverity("error");
          setErrMsg(`Your ${destinationWalletObject.title} ${param.display_name} is required`);
          setOpen(true);
          return false;
        }

        return true;
      });

      if (!passed) {
        return;
      }
    } else {
      setDestinationDetails({});
    }

    const params = {
      amount: sourceAmount * 100,
      source: {
        wallet: sourceWallet,
        currency: sourceCurrency,
      },
      destination: {
        wallet: destinationWallet,
        currency: destinationCurrency,
        details: destinationDetails,
      },
    };
    // console.log(params);

    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("switch.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          // console.log(response.data.data);
          navigate(`/switch/${response.data.data.transaction.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      {commercials !== null ? (
        <Dialog open={showConfirmDialog} fullWidth maxWidth="xs">
          <DialogTitle>Confirm Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {sourceWalletObject !== null && destinationWalletObject !== null ? (
                <MDBox mt={1} display="flex" alignItems="center" justifyContent="space-evenly">
                  <MDBox display="flex" alignItems="center" justifyContent="left">
                    <img
                      alt=""
                      src={`${ApiConfig.api_media_url}${sourceWalletObject.logo}`}
                      width="45"
                    />
                  </MDBox>
                  <MDBox>
                    <Icon color="success">east_circle</Icon>
                  </MDBox>
                  <MDBox display="flex" alignItems="center" justifyContent="left">
                    <img
                      alt=""
                      src={`${ApiConfig.api_media_url}${destinationWalletObject.logo}`}
                      width="45"
                    />
                  </MDBox>
                </MDBox>
              ) : (
                <> </>
              )}
              <MDBox p={2}>
                {sourceAmount !== null ? (
                  <MDBox mt={5} display="flex" justifyContent="space-between">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>You Send: </b>
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="light">
                      {sourceCurrency}&nbsp;
                      {parseFloat(sourceAmount).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </MDBox>
                ) : (
                  <> </>
                )}

                <MDBox mt={1} display="flex" justifyContent="space-between">
                  <MDTypography variant="h6" fontWeight="light">
                    <b>Network Fee: </b>
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    {sourceCurrency}&nbsp;
                    {(commercials.fee / 100).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </MDTypography>
                </MDBox>
                <MDBox mt={1} display="flex" justifyContent="space-between">
                  <MDTypography variant="h6" fontWeight="light">
                    <b>Exchange Rate: </b>
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    {destinationCurrency}{" "}
                    {commercials.rate >= 1
                      ? commercials.rate.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : commercials.rate.toFixed(8)}
                  </MDTypography>
                </MDBox>
                <MDBox mt={1} display="flex" justifyContent="space-between">
                  <MDTypography variant="h6" fontWeight="light">
                    <b>You Get: </b>
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    {destinationCurrency}
                    &nbsp;
                    {(commercials.credit_amount / 100).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </MDTypography>
                </MDBox>
                <MDBox mt={2}>
                  {/* <PinInput
                values={pinValues}
                onChange={(value, index, values) => setPinValues(values)}
                length={4}
                mask
                autoTab
                placeholder="-"
                onComplete={(text) => {
                  let up = "";
                  text.forEach((itm) => {
                    up += itm;
                  });
                  setUserPin(up);
                }}
              /> */}
                </MDBox>
              </MDBox>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MDButton
              color="dark"
              variant="outlined"
              onClick={() => {
                setShowConfirmDialog(false);
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              color="success"
              variant="contained"
              onClick={() => {
                //   if (userPin !== null && userPin.length === 4) {
                //     setShowConfirmDialog(false);
                //   }
                setShowConfirmDialog(false);
                createTransaction();
              }}
            >
              Proceed
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3} mb={10}>
        <MDBox>
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h4">Alero Switch</MDTypography>
              <MDTypography mt={2} variant="h6" fontWeight="light">
                Move your money seamlessly and securely across multiple digital wallets.
              </MDTypography>
            </MDBox>
          </Card>
        </MDBox>

        <MDBox mt={5}>
          <Card>
            <MDBox p={3}>
              <MDBox>
                <Grid container spacing={6}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="medium">
                        From:
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={6} md={8} lg={8}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Digital Wallet</InputLabel>
                            <Select
                              label="Digital Wallet"
                              onChange={(e) => handleSourceWalletChange(e.target.value)}
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={sourceWallet || ""}
                            >
                              {
                                // --> Notice below changes
                                digitalWallets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  digitalWallets.map((record) => (
                                    <MenuItem value={record.code}>
                                      <MDBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="left"
                                      >
                                        <img
                                          alt=""
                                          src={`${ApiConfig.api_media_url}${record.logo}`}
                                          width="20"
                                          mr={3}
                                        />
                                        <MDBox ml={2}>{record.title}</MDBox>
                                      </MDBox>
                                    </MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6} md={4} lg={4}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Currency</InputLabel>
                            <Select
                              label="Currency"
                              onChange={(e) => setSourceCurrency(e.target.value)}
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={sourceCurrency || ""}
                            >
                              {
                                // --> Notice below changes
                                sourceCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  sourceCurrencies.map((record) => (
                                    <MenuItem value={record.currency_code}>
                                      {record.currency_code}
                                    </MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="medium">
                        To:
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={6} md={8} lg={8}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Digital Wallet</InputLabel>
                            <Select
                              label="Digital Wallet"
                              onChange={(e) => handleDestinationWalletChange(e.target.value)}
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={destinationWallet || ""}
                            >
                              {
                                // --> Notice below changes
                                digitalWallets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  digitalWallets.map((record) => {
                                    if (sourceWallet !== null) {
                                      if (record.code !== sourceWallet) {
                                        return (
                                          <MenuItem value={record.code}>
                                            <MDBox
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="left"
                                            >
                                              <img
                                                alt=""
                                                src={`${ApiConfig.api_media_url}${record.logo}`}
                                                width="20"
                                                mr={3}
                                              />
                                              <MDBox ml={2}>{record.title}</MDBox>
                                            </MDBox>
                                          </MenuItem>
                                        );
                                      }
                                    }
                                    return null;
                                  })
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6} md={4} lg={4}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Currency</InputLabel>
                            <Select
                              label="Currency"
                              onChange={(e) => setDestinationCurrency(e.target.value)}
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={destinationCurrency || ""}
                            >
                              {
                                // --> Notice below changes
                                destinationCurrencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  destinationCurrencies.map((record) => (
                                    <MenuItem value={record.currency_code}>
                                      {record.currency_code}
                                    </MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox mt={6}>
                <Grid container spacing={6}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox>
                      <MDTypography variant="caption" fontWeight="medium">
                        Amount to send:
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDInput
                        name="sourceAmount"
                        label={sourceAmountLabel}
                        sx={{ minWidth: 120, width: "100%" }}
                        onChange={(e) => setSourceAmount(e.target.value)}
                        value={sourceAmount || ""}
                        // InputProps={{
                        //   startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                        //   ariaLabel: "weight",
                        // }}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    {destinationWalletObject !== null ? (
                      <MDBox>
                        {destinationWalletObject.code === "ALERO" ? (
                          <MDBox display="flex" justifyContent="center" p={2}>
                            <Alert severity="info">
                              <MDTypography variant="h6" fontWeight="light">
                                Funds will be deposited into your Alero {destinationCurrency}{" "}
                                balance instantly.
                              </MDTypography>
                            </Alert>
                          </MDBox>
                        ) : (
                          <MDBox>
                            <MDTypography variant="caption" fontWeight="medium">
                              Enter your {destinationWalletObject.title} details.
                            </MDTypography>
                            {destinationWalletObject.parameters.map((param) => (
                              <MDBox mt={2}>
                                <MDInput
                                  name={param.key}
                                  label={param.display_name}
                                  sx={{ minWidth: 120, width: "100%" }}
                                  // value={destinationDetails[param.key] || ""}
                                  onChange={(e) => {
                                    destinationDetails[param.key] = e.target.value;
                                    setDestinationDetails(destinationDetails);
                                  }}
                                />
                              </MDBox>
                            ))}
                          </MDBox>
                        )}
                      </MDBox>
                    ) : (
                      <> </>
                    )}
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox mt={5}>
                <Divider />
              </MDBox>
              <MDBox mb={3} mt={5} display="flex" justifyContent="center">
                <MDButton
                  variant="contained"
                  color="dark"
                  sx={{ minWidth: "240px", width: "50%" }}
                  onClick={() => calculate()}
                >
                  Calculate
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={3}>
          <Card>
            <MDBox p={3}>
              <MDBox
                pt={2}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" fontWeight="medium">
                  Transactions
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <DataTable
                  table={{ columns: tableColumns, rows: transactions }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AleroSwitch;
